import React, { useState, useEffect } from "react";
import "./Hero.css";
import { useImageStore } from "../../stores/useImageStores";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState("hero-slide");
  const { imagesByCategory, getImagesByCategory } = useImageStore();
  const images = imagesByCategory.hero || [];
  const navigate = useNavigate();

  useEffect(() => {
    const fetchImages = async () => {
      await getImagesByCategory("hero"); // Fetch images from backend
    };
    fetchImages();
  }, [getImagesByCategory]);

  useEffect(() => {
    if (images.length === 0) return;

    // Auto-switch images every 3 seconds
    const interval = setInterval(() => {
      setFadeClass("hero-slide");
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  return (
    <div className="hero-carousel">
      {images.length > 0 ? (
        <>
          {/* Previous Arrow */}
          <div
            className="arrow arrow-left"
            onClick={() => {
              setFadeClass("hero-slide");
              setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
            }}
          >
            &#10094; {/* Left arrow icon */}
          </div>

          {/* Current Slide */}
          <div className={fadeClass} onAnimationEnd={() => setFadeClass("hero-slide")}>
            <img src={images[currentIndex]?.image_url} alt={`Slide ${currentIndex}`} decoding="async" />
            <div className="hero-overlay">
              <h2>ELEGANCE MEETS SIMPLICITY</h2>
              <button onClick={() => navigate("/new")}>Shop Now</button> {/* <-- navigate to /new */}
            </div>
          </div>

          {/* Next Arrow */}
          <div
            className="arrow arrow-right"
            onClick={() => {
              setFadeClass("hero-slide");
              setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
            }}
          >
            &#10095; {/* Right arrow icon */}
          </div>
        </>
      ) : (
        <div className="hero-placeholder">
          <h2>No images available</h2>
        </div>
      )}
    </div>
  );
};

export default Hero;
